/* Alfa Vitamins theme JS
   Behavior ported from the Claude Design prototype Component class:
   cart drawer (Shopify AJAX Cart API), PDP buy box, gallery, menu drawer,
   Wellness Assistant quiz, carousels, FAQ accordions. */
(function () {
  'use strict';

  var settings = window.themeSettings || {};
  var rootUrl = settings.rootUrl || '/';
  var drawerReturnFocus = new Map();
  var cartBusy = false;
  var cartFocus = null;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = settings.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1]);
  }

  /* ---------- Drawers ---------- */
  function openDrawer(id, trigger) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.classList.contains('is-open')) return;
    var returnFocus = trigger || document.activeElement;
    if (!returnFocus || returnFocus === document.body || !returnFocus.isConnected || typeof returnFocus.focus !== 'function') returnFocus = qs('[data-cart-open]');
    drawerReturnFocus.set(id, returnFocus);
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    var focusTarget = qs('.drawer__panel button:not([disabled]), .drawer__panel a[href], .drawer__panel input:not([disabled])', el);
    if (focusTarget) focusTarget.focus();
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (!el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    var previousFocus = drawerReturnFocus.get(id);
    if (!previousFocus || !previousFocus.isConnected || previousFocus.disabled) previousFocus = qs('[data-cart-open]');
    if (previousFocus) previousFocus.focus();
    drawerReturnFocus.delete(id);
    if (!qs('.drawer.is-open')) document.documentElement.style.overflow = '';
  }

  /* ---------- Cart ---------- */
  function updateCartCounts(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function cartMessage(key, fallback) {
    return (settings.cartMessages && settings.cartMessages[key]) || fallback;
  }

  function setCartBusy(busy) {
    cartBusy = busy;
    if (busy) {
      qsa('[data-buy-now], [data-add-to-cart], [data-add-variant], [data-cart-plus], [data-cart-minus], [data-cart-remove], #CartDrawer [name="checkout"], .cart-page__foot button').forEach(function (button) {
        if (!button.hasAttribute('data-cart-pending')) button.dataset.cartPending = String(button.disabled);
        button.disabled = true;
      });
    } else {
      qsa('[data-cart-pending]').forEach(function (button) {
        button.disabled = button.hasAttribute('data-cart-unavailable') ? button.dataset.cartUnavailable === 'true' : button.dataset.cartPending === 'true';
        delete button.dataset.cartPending;
      });
    }
    var content = qs('#CartDrawer [data-cart-drawer-content]');
    if (content) content.setAttribute('aria-busy', String(busy));
  }

  function rememberCartFocus(container) {
    var focused = document.activeElement;
    if (!container.contains(focused)) return;
    var action = ['data-cart-plus', 'data-cart-minus', 'data-cart-remove', 'data-add-variant', 'data-cart-close'].find(function (attr) { return focused.hasAttribute(attr); });
    cartFocus = { action: action, value: action && focused.getAttribute(action), index: qsa('.cart-item', container).indexOf(focused.closest('.cart-item')) };
  }

  function restoreCartFocus() {
    if (!cartFocus) return;
    var drawer = qs('#CartDrawer.is-open');
    if (drawer) {
      var target = cartFocus.action && qsa('[' + cartFocus.action + ']', drawer).find(function (button) { return button.getAttribute(cartFocus.action) === cartFocus.value; });
      if (!target && cartFocus.action && cartFocus.index >= 0) {
        var rows = qsa('.cart-item', drawer);
        var row = rows[Math.min(cartFocus.index, rows.length - 1)];
        if (row) target = qs('[' + cartFocus.action + ']', row);
      }
      if (!target || target.disabled) target = qs('.drawer__panel [data-cart-close]', drawer);
      if (target) target.focus();
    }
    cartFocus = null;
  }

  function renderCartDrawer(html) {
    var container = qs('#CartDrawer [data-cart-drawer-content]');
    if (!container || typeof html !== 'string' || !html.trim()) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-cart-drawer-content]', doc);
    var count = fresh && qs('[data-drawer-item-count]', fresh);
    if (!count || !/^\d+$/.test(count.getAttribute('data-drawer-item-count'))) return false;
    rememberCartFocus(container);
    container.innerHTML = fresh.innerHTML;
    updateCartCounts(count.getAttribute('data-drawer-item-count'));
    if (cartBusy) setCartBusy(true);
    return true;
  }

  function refreshCartDrawer(sectionsHtml) {
    if (renderCartDrawer(sectionsHtml)) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error(cartMessage('refreshError', 'Could not refresh your cart.'));
        return response.json();
      })
      .then(function (data) {
        if (!renderCartDrawer(data && data['cart-drawer'])) throw new Error(cartMessage('refreshError', 'Could not refresh your cart.'));
      });
  }

  function showCartError(message, source) {
    var drawer = document.getElementById('CartDrawer');
    var product = source && source.closest('[data-product-form]');
    var error = product && !(drawer && drawer.classList.contains('is-open')) ? qs('[data-product-error]', product) : null;
    if (!error && drawer) {
      error = qs('[data-cart-error]', drawer);
      if (!error) {
        error = document.createElement('p');
        error.setAttribute('data-cart-error', '');
        error.setAttribute('role', 'alert');
        error.style.margin = '0 24px 16px';
        var header = qs('.cart-drawer__header', drawer);
        if (header) header.after(error);
        else qs('[data-cart-drawer-content]', drawer).prepend(error);
      }
      var errorReturnFocus = source;
      if (source && source.closest('#QuizDrawer')) {
        errorReturnFocus = drawerReturnFocus.get('QuizDrawer') || qs('[data-cart-open]');
        closeDrawer('QuizDrawer');
      }
      openDrawer('CartDrawer', errorReturnFocus);
    }
    if (!error) { alert(message); return; }
    error.textContent = message + ' ';
    var link = document.createElement('a');
    link.href = rootUrl + 'cart';
    link.textContent = cartMessage('viewCart', 'View cart');
    error.append(link);
    error.hidden = false;
  }

  function mutateCart(endpoint, payload, source, onSuccess, checkoutAfter) {
    if (cartBusy) return Promise.resolve(false);
    setCartBusy(true);
    qsa('[data-product-error], [data-cart-error]').forEach(function (error) { error.hidden = true; error.textContent = ''; });
    var changed = false;
    payload.sections = 'cart-drawer';
    payload.sections_url = window.location.pathname;
    return fetch(rootUrl + 'cart/' + endpoint + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var error = new Error(data.description || data.message || cartMessage(endpoint === 'add' ? 'addError' : 'changeError', 'Could not update your cart.'));
            error.cartUncertain = response.status === 400 || response.status >= 500;
            throw error;
          }
          return data;
        });
      })
      .then(function (data) {
        changed = true;
        if (checkoutAfter) { window.location.assign(rootUrl + 'checkout'); return; }
        if (window.location.pathname.replace(/\/$/, '') === (rootUrl + 'cart').replace(/\/$/, '')) {
          window.location.reload();
          return;
        }
        return refreshCartDrawer(data && data.sections && data.sections['cart-drawer']).then(onSuccess);
      })
      .catch(function (error) {
        if (changed) { window.location.assign(rootUrl + 'cart'); return; }
        if (error && error.cartUncertain === false) { showCartError(error.message, source); return; }
        var message = cartMessage('uncertainError', "We couldn't confirm the cart update. Check your cart before trying again.");
        return refreshCartDrawer().then(function () { showCartError(message, source); }, function () { window.location.assign(rootUrl + 'cart'); });
      })
      .finally(function () { setCartBusy(false); restoreCartFocus(); });
  }

  function cartAdd(items, openAfter, source) {
    var drawer = document.getElementById('CartDrawer');
    var wasOpen = drawer && drawer.classList.contains('is-open');
    return mutateCart('add', { items: items }, source, function () {
      var returnFocus = source;
      if (source && source.closest('#QuizDrawer')) {
        returnFocus = drawerReturnFocus.get('QuizDrawer') || qs('[data-cart-open]');
        closeDrawer('QuizDrawer');
      }
      if (openAfter !== false && (!wasOpen || drawer.classList.contains('is-open'))) openDrawer('CartDrawer', returnFocus);
    });
  }

  function cartChange(key, qty, source) {
    if (!key || !Number.isInteger(qty) || qty < 0) return Promise.resolve(false);
    return mutateCart('change', { id: key, quantity: qty }, source);
  }

  /* ---------- PDP buy box ---------- */
  function initProductForm(root) {
    if (root.dataset.productFormReady) return;
    var variantsEl = qs('[data-product-variants]', root);
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    if (!Array.isArray(variants) || !variants.length) return;
    root.dataset.productFormReady = 'true';

    var planAliases = {};
    var aliasesEl = qs('[data-subscription-plan-aliases]', root);
    if (aliasesEl) {
      try { planAliases = JSON.parse(aliasesEl.textContent); } catch (e) { planAliases = {}; }
    }

    var state = {
      variantId: Number(root.getAttribute('data-selected-variant')),
      plan: root.getAttribute('data-default-plan') || 'one',
      qty: 1,
      renderedVariantId: null,
      sellingPlanId: Number(root.getAttribute('data-preferred-selling-plan')) || null
    };
    var productRequiresSellingPlan = root.getAttribute('data-requires-selling-plan') === 'true';

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === state.variantId) return variants[i];
      }
      return variants[0];
    }

    function visibleSellingPlans(variant) {
      var plans = variant.selling_plans || [];
      return plans.filter(function (plan) {
        var canonicalId = planAliases[String(plan.id)];
        var canonical = plans.find(function (other) { return other.id === canonicalId; });
        return !canonical || canonical.id === plan.id ||
          canonical.name.trim().toLowerCase() !== plan.name.trim().toLowerCase() ||
          canonical.first_price !== plan.first_price ||
          canonical.recurring_price !== plan.recurring_price ||
          canonical.first_pct !== plan.first_pct;
      });
    }

    function sellingPlan(variant) {
      var plans = visibleSellingPlans(variant);
      var selected = plans.find(function (p) { return p.id === state.sellingPlanId; });
      var canonicalId = planAliases[String(state.sellingPlanId)];
      return selected || plans.find(function (p) { return p.id === canonicalId; }) || plans[0] || null;
    }

    function render() {
      var v = currentVariant();
      if (state.renderedVariantId && state.renderedVariantId !== v.id) {
        var hero=qs('[data-product-hero]',root);
        if(hero && v.artwork){hero.src=v.artwork;hero.removeAttribute('srcset');}
        var heroArt=qs('[data-product-artwork]',root);if(heroArt)heroArt.classList.toggle('product-artwork--catalog',v.artwork.indexOf('alfa-design-rebuild-')<0);
        var heroThumb=qs('[data-thumb="hero"] img',root);
        if(heroThumb && v.artwork){heroThumb.src=v.artwork;heroThumb.removeAttribute('srcset');var thumbArt=heroThumb.closest('.product-artwork');if(thumbArt)thumbArt.classList.toggle('product-artwork--catalog',v.artwork.indexOf('alfa-design-rebuild-')<0);}
        var heroButton=qs('[data-thumb="hero"]',root);
        if(heroButton) heroButton.click();
      }
      var gallery=qs('[data-gallery]',root);
      if(gallery){
        gallery.dataset.heroMediaId=v.hero_media_id || '';
        gallery.dispatchEvent(new CustomEvent('alfa:hero-media-change', { detail: { id: v.hero_media_id || '' } }));
      }
      state.renderedVariantId=v.id;
      var stock=qs('[data-stock-note]',root);if(stock)stock.hidden=!v.available;
      var plan = sellingPlan(v);
      var hasPlan = !!plan;
      var requiresSellingPlan = !!v.requires_selling_plan || productRequiresSellingPlan;
      if (requiresSellingPlan) state.plan = 'sub';
      else if (!hasPlan) state.plan = 'one';
      state.sellingPlanId=plan ? plan.id : null;
      var frequency=qs('[data-sub-frequency]',root);if(frequency)frequency.hidden=!hasPlan || state.plan!=='sub';
      var subscriptionDetails = qs('[data-subscription-details]', root);
      if (subscriptionDetails) subscriptionDetails.hidden = !hasPlan || state.plan !== 'sub';
      var planSelect=qs('[data-selling-plan-select]',root);
      if(planSelect){planSelect.replaceChildren();visibleSellingPlans(v).forEach(function(p){var o=document.createElement('option');o.value=p.id;o.textContent=p.name;o.selected=p.id===state.sellingPlanId;planSelect.append(o);});}

      qsa('[data-variant-btn]', root).forEach(function (btn) {
        var selected=Number(btn.getAttribute('data-variant-btn')) === v.id;
        btn.classList.toggle('is-active', selected);btn.setAttribute('aria-pressed', String(selected));
      });

      var subOption = qs('[data-plan-btn="sub"]', root);
      if (subOption) {
        subOption.hidden = !hasPlan;
        subOption.style.display = hasPlan ? '' : 'none';
        subOption.classList.toggle('is-active', state.plan === 'sub');
        subOption.setAttribute('aria-pressed', String(state.plan==='sub'));
        if (hasPlan) {
          var first = qs('[data-sub-first]', root);
          var was = qs('[data-sub-was]', root);
          var recur = qs('[data-sub-recur]', root);
          var pct = qs('[data-sub-pct]', root);
          if (first) first.textContent = formatMoney(plan.first_price);
          if (was) {was.textContent = formatMoney(v.price);was.hidden=plan.first_price>=v.price;}
          var subTitle=qs('[data-sub-title]',root);if(subTitle)subTitle.textContent=plan.first_price<v.price?'Subscribe & Save':'Subscribe';
          var subBadge=qs('[data-sub-badge]',root);if(subBadge)subBadge.hidden=plan.first_price>=v.price;
          if (recur) recur.textContent = formatMoney(plan.recurring_price);
          if(pct){pct.textContent=plan.first_pct>0?plan.first_pct+'% SAVINGS':'';pct.hidden=plan.first_pct<=0;}
        }
      }
      var oneOption = qs('[data-plan-btn="one"]', root);
      if (oneOption) {
        oneOption.hidden = requiresSellingPlan || v.price <= 0;
        oneOption.classList.toggle('is-active', state.plan === 'one');
        oneOption.setAttribute('aria-pressed', String(state.plan==='one'));
        var onePrice = qs('[data-one-price]', root);
        if (onePrice) onePrice.textContent = formatMoney(v.price);
      }

      var unit = (state.plan === 'sub' && plan) ? plan.first_price : v.price;
      var headline = qs('[data-price-headline]', root);
      if (headline) headline.textContent = v.price > 0 ? formatMoney(unit) : root.getAttribute('data-zero-price-text');
      var quantityRow = qs('[data-quantity-row]', root);
      if (quantityRow) quantityRow.hidden = v.price <= 0;

      var qtyEl = qs('[data-qty-value]', root);
      if (qtyEl) qtyEl.textContent = state.qty;

      var cta = qs('[data-atc-label]', root);
      if (cta) cta.textContent = root.getAttribute('data-atc-text') + ' — ' + formatMoney(unit * state.qty);

      var atc = qs('[data-add-to-cart]', root);
      if (atc) {
        var purchasable = v.available && (!requiresSellingPlan || hasPlan);
        atc.dataset.cartUnavailable = String(!purchasable);
        atc.disabled = cartBusy || !purchasable;
        if (v.price <= 0 && cta) cta.textContent = root.getAttribute('data-zero-price-text');
        if (v.price > 0 && !purchasable && cta) cta.textContent = v.available ? cartMessage('unavailable', 'This option is unavailable.') : (root.getAttribute('data-soldout-text') || 'SOLD OUT');
      }

      var buyNow = qs('[data-buy-now]', root);
      if (buyNow) {
        buyNow.hidden = v.price <= 0;
        buyNow.dataset.cartUnavailable = String(!v.available || (requiresSellingPlan && !hasPlan));
        buyNow.disabled = cartBusy || buyNow.dataset.cartUnavailable === 'true';
      }
      var urlVariant = new URL(window.location.href);
      urlVariant.searchParams.set('variant', v.id);
      if (state.plan === 'sub' && plan) urlVariant.searchParams.set('selling_plan', plan.id);
      else urlVariant.searchParams.delete('selling_plan');
      window.history.replaceState({}, '', urlVariant.toString());
    }

    root.addEventListener('change',function(e){if(e.target.matches('[data-selling-plan-select]')){state.sellingPlanId=Number(e.target.value);render();}});

    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-variant-btn]'))) {
        state.variantId = Number(t.getAttribute('data-variant-btn'));
        render();
      } else if ((t = e.target.closest('[data-plan-btn]'))) {
        var selectedVariant = currentVariant();
        if (t.getAttribute('data-plan-btn') === 'one' && (selectedVariant.requires_selling_plan || productRequiresSellingPlan)) return;
        state.plan = t.getAttribute('data-plan-btn');
        render();
      } else if (e.target.closest('[data-qty-inc]')) {
        state.qty = state.qty + 1;
        render();
      } else if (e.target.closest('[data-qty-dec]')) {
        state.qty = Math.max(1, state.qty - 1);
        render();
      } else if (e.target.closest('[data-add-to-cart], [data-buy-now]')) {
        if (cartBusy) return;
        var v = currentVariant();
        if (!v.available) return;
        var plan = sellingPlan(v);
        var requiresSellingPlan = !!v.requires_selling_plan || productRequiresSellingPlan;
        if (requiresSellingPlan && !plan) {
          showCartError(cartMessage('unavailable', 'This option is unavailable. Please choose another option.'), e.target);
          return;
        }
        var item = { id: v.id, quantity: state.qty };
        if ((requiresSellingPlan || state.plan === 'sub') && plan) item.selling_plan = plan.id;
        var buyNowButton = e.target.closest('[data-buy-now]');
        if (buyNowButton) mutateCart('add', { items: [item] }, buyNowButton, null, true);
        else cartAdd([item], true, e.target.closest('[data-add-to-cart]'));
      }
    });

    render();
  }

  /* ---------- PDP gallery ---------- */
  function initGallery(root) {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';
    var main=qs('[data-gallery-main]',root);
    var thumbs=qsa('[data-thumb]',root);
    var panels=qsa('[data-media-panel]',root);
    var gesture=null;
    function navigableThumbs(){return thumbs.filter(function(thumb){return !thumb.hidden;});}
    function select(thumb) {
      if(!thumb || thumb.hidden) return;
      var id=thumb.getAttribute('data-thumb');
      thumbs.forEach(function(b){var active=b===thumb;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active));});
      panels.forEach(function(p){
        p.hidden=p.getAttribute('data-media-panel')!==id;
        if(p.hidden) qsa('video',p).forEach(function(v){v.pause();});
      });
      var rail=thumb.parentElement;
      if(rail) {
        var box=thumb.getBoundingClientRect(), bounds=rail.getBoundingClientRect();
        if(box.left<bounds.left) rail.scrollLeft+=box.left-bounds.left-3;
        else if(box.right>bounds.right) rail.scrollLeft+=box.right-bounds.right+3;
      }
    }
    function syncHeroDuplicate(mediaId) {
      var duplicateId=mediaId ? String(mediaId) : '';
      thumbs.forEach(function(thumb){
        var duplicate=thumb.getAttribute('data-thumb')!=='hero' && thumb.getAttribute('data-thumb')===duplicateId;
        thumb.hidden=duplicate;
      });
      var active=thumbs.find(function(thumb){return thumb.getAttribute('aria-pressed')==='true';});
      if(active && active.hidden) select(qs('[data-thumb="hero"]',root));
    }
    function step(direction) {
      var available=navigableThumbs();
      if(available.length<2) return available[0];
      var index=available.findIndex(function(b){return b.getAttribute('aria-pressed')==='true';});
      if(index<0) index=0;
      var next=available[(index+direction+available.length)%available.length];
      if(next) select(next);
      return next;
    }
    root.addEventListener('alfa:hero-media-change',function(event){syncHeroDuplicate(event.detail && event.detail.id);});
    syncHeroDuplicate(root.dataset.heroMediaId);
    root.addEventListener('click',function(e){
      var thumb=e.target.closest('[data-thumb]');
      if(thumb && root.contains(thumb)) select(thumb);
    });
    root.addEventListener('keydown',function(e){
      if(!e.target.closest('[data-thumb]') || (e.key!=='ArrowLeft' && e.key!=='ArrowRight')) return;
      e.preventDefault();
      var next=step(e.key==='ArrowLeft'?-1:1);
      if(next) next.focus({preventScroll:true});
    });
    if(!main || thumbs.length<2) return;
    panels.forEach(function(panel){
      if(qs('video,iframe,model-viewer',panel)) return;
      panel.style.touchAction='pan-y pinch-zoom';
      qsa('img',panel).forEach(function(img){img.draggable=false;img.style.userSelect='none';});
    });
    main.addEventListener('pointerdown',function(e){
      if(e.isPrimary===false) {gesture=null;return;}
      if(e.button!==0 || e.target.closest('video,iframe,model-viewer,button,a,input')) return;
      var panel=e.target.closest('[data-media-panel]');
      if(!panel || qs('video,iframe,model-viewer',panel)) return;
      gesture={id:e.pointerId,x:e.clientX,y:e.clientY};
      main.setPointerCapture(e.pointerId);
      if(e.pointerType==='mouse') e.preventDefault();
    });
    main.addEventListener('pointerup',function(e){
      if(!gesture || gesture.id!==e.pointerId) return;
      var dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
      gesture=null;
      if(Math.abs(dx)>=40 && Math.abs(dx)>Math.abs(dy)*1.25) step(dx<0?1:-1);
    });
    main.addEventListener('pointercancel',function(){gesture=null;});
    main.addEventListener('lostpointercapture',function(){gesture=null;});
    main.addEventListener('dragstart',function(e){if(e.target.tagName==='IMG') e.preventDefault();});
  }

  /* ---------- Carousels ---------- */
  function initCarousel(root) {
    var scroller = qs('[data-carousel-scroll]', root);
    if (!scroller) return;
    var step = Number(root.getAttribute('data-carousel-step')) || 644;
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-carousel-prev]')) scroller.scrollBy({ left: -step, behavior: 'smooth' });
      if (e.target.closest('[data-carousel-next]')) scroller.scrollBy({ left: step, behavior: 'smooth' });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.faq-item__q');
      if (!btn) return;
      var item = btn.closest('.faq-item');
      var wasOpen = item.classList.contains('is-open');
      qsa('.faq-item.is-open', root).forEach(function (i) { i.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
    });
  }

  /* ---------- Wellness Assistant quiz ---------- */
  function initQuiz() {
    var drawer=document.getElementById('QuizDrawer');if(!drawer)return;
    function reset(){qsa('[data-guide-results]',drawer).forEach(function(p){p.hidden=true;});qs('[data-guide-choices]',drawer).hidden=false;}
    drawer.addEventListener('click',function(e){
      var button=e.target.closest('[data-guide-goal]');
      if(button){
        qs('[data-guide-choices]',drawer).hidden=true;
        qsa('[data-guide-results]',drawer).forEach(function(p){p.hidden=p.getAttribute('data-guide-results')!==button.getAttribute('data-guide-goal');});
        var heading=qs('[data-guide-results]:not([hidden]) h3',drawer);if(heading)heading.focus();
      }
      if(e.target.closest('[data-guide-back]')){reset();qs('[data-guide-goal]',drawer).focus();}
    });
    document.addEventListener('click',function(e){
      if(!e.target.closest('[data-quiz-open]'))return;
      e.preventDefault();
      var menu=document.querySelector('[data-av-mnav]');
      if(menu){menu.classList.remove('is-open');document.body.style.overflow='';}
      reset();openDrawer('QuizDrawer');
    });
  }

  /* ---------- Newsletter forms (footer + home section) ---------- */
  function initNewsletterForms() {
    qsa('[data-newsletter-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        try { localStorage.setItem('alfa_newsletter_signup', new Date().toISOString()); } catch (e) {}
      });
    });
  }

  /* ---------- Global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer('CartDrawer', e.target.closest('[data-cart-open]')); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer('CartDrawer'); return; }
    if (e.target.closest('[data-menu-open]')) { openDrawer('MenuDrawer'); return; }
    if (e.target.closest('[data-menu-close]')) { closeDrawer('MenuDrawer'); return; }
    if (e.target.closest('[data-quiz-close]')) { closeDrawer('QuizDrawer'); return; }

    if ((t = e.target.closest('[data-add-variant]'))) {
      e.preventDefault();
      var id = Number(t.getAttribute('data-add-variant'));
      if (id) cartAdd([{ id: id, quantity: 1 }], true, t);
      return;
    }
    if ((t = e.target.closest('[data-cart-plus]'))) {
      cartChange(t.getAttribute('data-cart-plus'), Number(t.getAttribute('data-line-qty')) + 1, t);
      return;
    }
    if ((t = e.target.closest('[data-cart-minus]'))) {
      var next = Number(t.getAttribute('data-line-qty')) - 1;
      cartChange(t.getAttribute('data-cart-minus'), Math.max(1, next), t);
      return;
    }
    if ((t = e.target.closest('[data-cart-remove]'))) {
      cartChange(t.getAttribute('data-cart-remove'), 0, t);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if(e.key==='Tab'){
      var open=qs('.drawer.is-open');
      if(open){var f=qsa('.drawer__panel button:not([disabled]), .drawer__panel a[href], .drawer__panel input',open).filter(function(el){return el.getClientRects().length;});
        if(f.length && e.shiftKey && document.activeElement===f[0]){e.preventDefault();f[f.length-1].focus();}
        else if(f.length && !e.shiftKey && document.activeElement===f[f.length-1]){e.preventDefault();f[0].focus();}
      }
    }
    if (e.key === 'Escape') {
      closeDrawer('CartDrawer');
      closeDrawer('QuizDrawer');
      closeDrawer('MenuDrawer');
    }
  });

  function initTheme() {
    qsa('[data-product-form]').forEach(initProductForm);
    qsa('[data-gallery]').forEach(initGallery);
    qsa('[data-carousel]').forEach(initCarousel);
    qsa('[data-faq]').forEach(initFaq);
    initQuiz();
    initNewsletterForms();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTheme, { once: true });
  else initTheme();
  document.addEventListener('shopify:section:load', function (event) {
    qsa('[data-product-form]', event.target).forEach(initProductForm);
    qsa('[data-gallery]', event.target).forEach(initGallery);
  });
})();

